import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/data';

const internalLinks = [
  { label: '品牌介紹', path: '/about' },
  { label: '合作通路', path: '/stores' },
  { label: '常見問題', path: '/faq' },
  { label: '聯絡我們', path: '/contact' },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-6 md:px-10 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          {/* Top: three-column layout */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
            {/* Column 1: 樂律文化 — formal brand identity */}
            <div>
              <Link to="/" className="inline-block mb-5 cursor-pointer" aria-label="樂律文化 LELYRIC — 回首頁">
                <img
                  src="https://storage.readdy-site.link/project_files/8e05c265-8616-48c2-b04c-6c0cd591d92e/12c767cc-4ca3-4d8a-9c68-e7b2e2764614_compressed_01logo.webp"
                  alt="樂律文化 LELYRIC 品牌視覺"
                  className="h-11 w-auto object-contain"
                  width="120"
                  height="120"
                  loading="lazy"
                />
              </Link>

              {/* Formal brand identity */}
              <div className="space-y-2 mb-4">
                <p className="text-[15px] font-semibold text-background-50/85 tracking-wide">
                  樂律文化
                </p>
                <p className="text-[13px] text-background-50/35 font-mono tracking-widest uppercase">
                  LELYRIC
                </p>
                <p className="text-[13px] text-background-50/35 leading-relaxed">
                  {siteConfig.brandCategory}
                </p>
              </div>

              <p className="text-[12px] text-background-50/30 font-mono mb-3 tracking-wide">
                {siteConfig.brandUrl.replace('https://', '')}
              </p>

              {/* Brand relationship */}
              <p className="text-[13px] text-background-50/50 leading-relaxed max-w-xs mb-3">
                {siteConfig.brandDescription}
              </p>

              {/* Content responsibility disclaimer */}
              <p className="text-[12px] text-background-50/30 leading-relaxed max-w-xs mb-2">
                {siteConfig.contentDisclaimer}
              </p>

              {/* Author viewpoint disclaimer */}
              <p className="text-[12px] text-background-50/25 leading-relaxed max-w-xs">
                {siteConfig.authorDisclaimer}
              </p>
            </div>

            {/* Column 2: 站內導覽 */}
            <div>
              <h4 className="text-[13px] font-semibold text-background-50/70 mb-4 tracking-wider uppercase whitespace-nowrap">
                樂律文化官網
              </h4>
              <ul className="flex flex-col gap-2.5">
                {internalLinks.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-[14px] text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Column 3: 外部資源 — three-site entry */}
            <div>
              <h4 className="text-[13px] font-semibold text-background-50/70 mb-4 tracking-wider uppercase whitespace-nowrap">
                相關網站
              </h4>
              <ul className="flex flex-col gap-3.5">
                <li>
                  <a
                    href={siteConfig.sonbookUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group inline-flex items-center gap-2 text-[14px] text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    崧博出版主站
                    <i className="ri-external-link-line text-[12px] text-background-50/30 group-hover:text-background-50/60 transition-colors"></i>
                  </a>
                  <p className="text-[12px] text-background-50/25 mt-0.5 ml-0 leading-relaxed">
                    出版資訊、品牌導覽與經銷品牌總覽
                  </p>
                </li>
                <li>
                  <a
                    href={siteConfig.catalogUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group inline-flex items-center gap-2 text-[14px] text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    崧博書籍資料庫
                    <i className="ri-external-link-line text-[12px] text-background-50/30 group-hover:text-background-50/60 transition-colors"></i>
                  </a>
                  <p className="text-[12px] text-background-50/25 mt-0.5 ml-0 leading-relaxed">
                    查詢完整書名、作者、ISBN 及出版資訊
                  </p>
                </li>
                <li>
                  <a
                    href={siteConfig.blogBooksUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group inline-flex items-center gap-2 text-[14px] text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    博客來品牌書目
                    <i className="ri-external-link-line text-[12px] text-background-50/30 group-hover:text-background-50/60 transition-colors"></i>
                  </a>
                </li>
              </ul>

              {/* Book data notice */}
              <div className="mt-5 pt-4 border-t border-background-50/8">
                <p className="text-[12px] text-background-50/25 leading-relaxed">
                  {siteConfig.bookDataNotice}
                </p>
              </div>

              {/* Sonbook brands entry */}
              <div className="mt-5 pt-4 border-t border-background-50/8">
                <a
                  href={siteConfig.sonbookUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whitespace-nowrap inline-flex items-center gap-2 text-[13px] text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer"
                >
                  查看崧博出版與其他經銷品牌
                  <i className="ri-arrow-right-line text-[12px]"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="mt-14 pt-7 border-t border-background-50/8 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-background-50/25 text-[12px]">
              &copy; {new Date().getFullYear()} {siteConfig.brandShortName} · {siteConfig.brandEnglishName}
            </p>
            <div className="flex items-center gap-4">
              <span className="text-background-50/18 text-[12px] font-mono">
                lelyric.sonbook.net
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}